export enum SOCKET_EVENTS {
  ON_JOIN_CONVERT_TEXT_TO_SPEECH = 'ON_JOIN_CONVERT_TEXT_TO_SPEECH',
  CONVERT_TEXT_TO_SPEECH_MESSAGE = 'CONVERT_TEXT_TO_SPEECH_MESSAGE',
  ON_JOIN_DEVICE = 'ON_JOIN_DEVICE',
  ON_LEFT_DEVICE = 'ON_LEFT_DEVICE',
  ON_JOIN_SEPAY_ROOM = 'ON_JOIN_SEPAY_ROOM',
  ON_LEFT_SEPAY_ROOM = 'ON_LEFT_SEPAY_ROOM',
  ON_JOIN_NOTIFICATION_ROOM = 'ON_JOIN_NOTIFICATION_ROOM',
  ON_LEFT_NOTIFICATION_ROOM = 'ON_LEFT_NOTIFICATION_ROOM',
  UPDATE_DEVICE = 'UPDATE_DEVICE',
  ACTIVED_DEVICE = 'ACTIVED_DEVICE',

  SEPAY_SUCCESS = 'SEPAY_SUCCESS',
  SEPAY_FAILURE = 'SEPAY_FAILURE',

  NEW_NOTIFICATION = 'NEW_NOTIFICATION',
}
